// extracted by mini-css-extract-plugin
export default {"container":"styles_container__j-pSC","containerImage":"styles_containerImage__8TxT0","link":"styles_link__capmH"};